module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/pigmyremittance/pigmyremittance.component.css
// module id = ./src/app/general-transaction/pigmyremittance/pigmyremittance.component.css
// module chunks = main